import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import Input from 'src/components/atomic/atom/Input'
import Svg from 'src/components/atomic/atom/Svg'
import { setPinHidden } from 'src/store/Reducer/page/loginPageSlice'
import Button from 'src/components/atomic/atom/Button'
import { useTranslation } from 'react-i18next'
import { RootState } from 'src/store/store'
import { LoginProps } from 'src/views/Account/Login'
import { useNavigate } from 'react-router-dom'
import { ColorHandler, InputBorderHandler } from 'src/utils/style.utils'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { commonUtils } from 'src/utils/common.utils'
import ErrTextBox from 'src/components/atomic/Molecules/ErrTextBox'
/*
 * 핀번호 확인 컴포넌트
 */
const PinInputForm = (props: { data: LoginProps }) => {
  const { SignInBtnHandler } = props.data
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { pinValue, pinHidden, Status } = useAppSelector((state: RootState) => state.LoginPage)
  const { errText } = useAppSelector((state: RootState) => state.common)
  const { handleEnterKeyDown } = commonUtils
  const TextLengthValid = pinValue?.length === 6

  return (
    <>
      <Span option={'small'} $text_align={'left'} color={COLOR.black60} $margin={'0 0 9px 0'}>
        {t('LOGIN.PIN_INPUT_TITLE', { defaultValue: 'Your PIN' })}
      </Span>
      <Input
        autoFocus={true}
        value={pinValue}
        option={'login_pin'}
        type={pinHidden ? 'password' : 'text'}
        onKeyDown={(e) => handleEnterKeyDown(e, SignInBtnHandler)}
        disabled={Status === 'pinMoreThanFiveTimes' || Status === 'isNotApp'}
        $border={InputBorderHandler(TextLengthValid, pinValue?.length !== 0 || errText !== null)}
      />
      <Svg
        name={pinHidden ? 'pin_Input_eyes' : 'pin_Input_eyes_active'}
        onClick={() => dispatch(setPinHidden(!pinHidden))}
        style={{
          top: pinHidden ? '-32px' : '-34px',
          right: '17px',
          float: 'right',
          position: 'relative',
        }}
      />
      <ErrTextBox>{errText}</ErrTextBox>
      <Button
        option={'bigDefault'}
        $bgColor={ColorHandler(TextLengthValid, 'brand_black10')}
        disabled={!TextLengthValid}
        onClick={SignInBtnHandler}
      >
        <Span option={'medium_bold'} color={ColorHandler(TextLengthValid, 'white_black30')}>
          {t('BUTTON.SIGN_IN', { defaultValue: 'Sign in' })}
        </Span>
      </Button>
      <Span
        option={'tiny'}
        $margin={'13px 0 0 0'}
        onClick={() => navigate('/reset')}
        style={{
          textDecoration: 'underline',
        }}
        className="pin_search_click"
      >
        {t('LOGIN.NOTIFICATION', { defaultValue: 'Forgot your PIN?' })}
      </Span>
    </>
  )
}
export default PinInputForm
